import React, { Fragment, useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { installFonts } from '../../actions/fonts';

import _ from 'lodash';
import { Helmet } from 'react-helmet';

function FontManager(props) {
  const dispatch = useDispatch();

  const availableFonts = useSelector(state => {
    var fonts = _.get(state, 'fonts.items') || [];
    const installed = _.get(state, 'fonts.installed');
    return fonts.filter(font => {
      return installed.some(item => item === font.id);
    }).filter(font => font.styleSheet != null);
  });

  return (
    <Helmet>
      {availableFonts.map(font => {
        return (
          <link key={font.id} rel="stylesheet" type="text/css" href={font.styleSheet} />
        );
      })}
    </Helmet>
  );
}

const useFont = (fonts) => {
  const dispatch = useDispatch();

  const fontToBeInstalled = useSelector(state => {
    const installed = _.get(state, 'fonts.installed');
    const availableFonts = _.get(state, 'fonts.items') || [];

    var filtered = (fonts || []).map(font => {
      if(typeof(font) === 'string'){
        return availableFonts.find(item => item.id === font);
      }

      return font;
    }).filter(font => {
      return font != null;
    }).filter(font => {
      return !installed.some(item => item === font.id);
    });

    return filtered;
  }, shallowEqual);

  useEffect(() => {
    if(_.size(fontToBeInstalled) > 0){
      dispatch(installFonts(fontToBeInstalled));
    }
  }, [fontToBeInstalled]);
}

const Fonts = {
  Manager: FontManager,
  useFont: useFont
};

export default Fonts;
